export default __webpack_public_path__ + "static/media/creditLock.0960b0be.svg";